import React from 'react'
import { Route, Switch, useParams } from 'react-router-dom'
import { RoleSysNotify } from '../../../../role/components/role-sys'
import { NoAccess } from '../../../../role/components/no-access'
import { NotifyPage } from './notify-page'
import { OverviewTab } from './overview-tab'
import { DeliveryLog } from './delivery-log'
import { TimelineView } from './timeline-page'
import { OutboxTab } from './outbox-tab'
import { DeadLetterTab } from './dead-letter-tab'
import { CapturesTab } from './captures-tab'
import { CredentialsTab } from './credentials-tab'
import { RolloutTab } from './rollout-tab'
import { CatalogueTab } from './catalogue-tab'
import { TestSendTab } from './test-send-tab'
import { NOTIFY_BASE } from './paths'


const StaffTimeline = () => {
  const { traceID } = useParams()
  return <TimelineView traceID={traceID} system />
}

// The staff Notifications section (spec section 13.1; SYS_NOTIFY read).
// Gated by its sidebar permission too, so a typed URL without it shows
// NoAccess. Every view asks the server for scope=system.
export const LayoutNotify = () =>
  <Route path={NOTIFY_BASE}>
    <RoleSysNotify accessRead fallback={<NoAccess what="notifications" />}>
      <NotifyPage>
        <Switch>
          <Route path="/admin/notify/deliveries"><DeliveryLog system /></Route>
          <Route path="/admin/notify/timeline/:traceID"><StaffTimeline /></Route>
          <Route path="/admin/notify/outbox"><OutboxTab /></Route>
          <Route path="/admin/notify/dead-letter"><DeadLetterTab /></Route>
          <Route path="/admin/notify/captures"><CapturesTab /></Route>
          <Route path="/admin/notify/rollout"><RolloutTab /></Route>
          <Route path="/admin/notify/catalogue"><CatalogueTab /></Route>
          <Route path="/admin/notify/credentials"><CredentialsTab /></Route>
          <Route path="/admin/notify/test-send"><TestSendTab /></Route>
          <Route path="/admin/notify" exact><OverviewTab /></Route>
        </Switch>
      </NotifyPage>
    </RoleSysNotify>
  </Route>
